import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "p-fluid grid justify-content-center align-items-center flex align-content-center mr-0",
  style: {"min-height":"100vh"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "field"
}
const _hoisted_4 = {
  key: 1,
  class: "field"
}
const _hoisted_5 = {
  key: 0,
  class: "field p-3"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Username*", -1)
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = {
  key: 1,
  class: "field p-3"
}
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "oldPassword" }, "Old Password*", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = {
  key: 2,
  class: "field p-3"
}
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = { for: "password" }
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = {
  key: 3,
  class: "field p-3"
}
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "passwordMatch" }, "Confirm Password*", -1)
const _hoisted_20 = {
  key: 0,
  class: "p-error"
}
const _hoisted_21 = { class: "p-3" }
const _hoisted_22 = { class: "grey col-12 text-center" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_25 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Panel, { class: "col-12 md:col-6 lg:col-4 p-panel-content" }, {
        header: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.styles.logo,
            style: {"height":"45px"}
          }, null, 8, _hoisted_2)
        ]),
        default: _withCtx(() => [
          (_ctx.loginError != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Message, {
                  severity: "error",
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginError = ''))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loginError), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.infoMessage != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_Message, {
                  severity: "info",
                  onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.infoMessage = ''))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.infoMessage), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (
          _ctx.handleLogin(!_ctx.v$.$invalid, !_ctx.v$.Email.$invalid, !_ctx.v$.Password.$invalid)
        ), ["prevent"]))
          }, [
            (!_ctx.isResetPasswordFlow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.v$.Email.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.Email.$model) = $event)),
                      id: "username",
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.Email.$invalid && _ctx.submitted })
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_7
                  ]),
                  (_ctx.v$.Email.$invalid && _ctx.submitted)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.Email.required.$message.replace("Value", "Username")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.buttonText === _ctx.ButtonTextOptions.UpdatePassword)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_Password, {
                      modelValue: _ctx.v$.OldPassword.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.OldPassword.$model) = $event)),
                      id: "oldPassword",
                      toggleMask: "",
                      feedback: false,
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.OldPassword.$invalid && _ctx.submitted })
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_11
                  ]),
                  (_ctx.v$.OldPassword.$invalid && _ctx.submitted)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.OldPassword.required.$message.replace("Value", "oldPassword")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.buttonText !== _ctx.ButtonTextOptions.RequestPasswordReset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_Password, {
                      modelValue: _ctx.v$.Password.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.Password.$model) = $event)),
                      id: "password",
                      toggleMask: "",
                      feedback: false,
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.Password.$invalid && _ctx.submitted })
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.buttonText === _ctx.ButtonTextOptions.ResetPassword ? 'New Password*' : 'Password*'), 1)
                  ]),
                  (_ctx.v$.Password.$invalid && _ctx.submitted)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.Password.required.$message.replace("Value", "Password")), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.buttonText !== _ctx.ButtonTextOptions.Login && _ctx.buttonText !== _ctx.ButtonTextOptions.RequestPasswordReset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_Password, {
                      modelValue: _ctx.v$.PasswordMatch.$model,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.PasswordMatch.$model) = $event)),
                      id: "passwordMatch",
                      toggleMask: "",
                      feedback: false,
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.PasswordMatch.$invalid })
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_19
                  ]),
                  (_ctx.v$.PasswordMatch.$invalid && _ctx.submitted)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_20, "Passwords do not match"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Button, {
                loading: _ctx.loginLoading,
                type: "submit",
                label: this.buttonText
              }, null, 8, ["loading", "label"])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_22, [
        _createElementVNode("a", {
          class: _normalizeClass([_ctx.loginActive, "login"]),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
        }, "Login", 2),
        _hoisted_23,
        _createElementVNode("a", {
          class: _normalizeClass([_ctx.registerActive, "login"]),
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleRegisterClick && _ctx.handleRegisterClick(...args)))
        }, "Register", 2),
        (_ctx.allowPasswordReset)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_24,
              _createElementVNode("a", {
                class: _normalizeClass([_ctx.resetPasswordActive, "login"]),
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleResetPasswordClick && _ctx.handleResetPasswordClick(...args)))
              }, "Reset Password", 2)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Footer, { class: "footer" })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showPasswordValidationError,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showPasswordValidationError) = $event)),
      header: "Password Validation Error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordError.split('\n'), (line) => {
            return (_openBlock(), _createElementBlock("span", {
              key: line,
              class: "block ml-1",
              style: {"min-height":"20px"}
            }, _toDisplayString(line), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}